import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { HttpRoutes } from 'utils/constant';

const removeApiPath = (path: string) =>
  path.startsWith('/user/') ? path.replace('/user', '') : path;

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/user',
  }),
  tagTypes: ['User API'],
  endpoints: (build) => ({
    getResumeData: build.query<{ isCompleted?: boolean }, string>({
      query: () => ({
        url: removeApiPath(HttpRoutes.resumeBuilderData),
        method: 'GET',
      }),
      transformResponse: (response: unknown) => response?.resumeBuilderData,
      providesTags: [{ type: 'User API', id: 'Resume Data' }],
    }),
  }),
});

export const { useGetResumeDataQuery } = userApi;
